import { Link } from 'react-router-dom';
import PageHeader from '@/components/feature/PageHeader';
import { useSEO } from '@/hooks/useSEO';
import { specialItems, formatViews } from '@/hooks/useContent';

export default function SpecialPage() {
  useSEO(
    '精选专题 - 一起艹',
    '一起艹精选专题合集：片单指南、现场盘点、年度话题回顾与新锐创作者图鉴，成体系地发现有趣内容。',
    '精选专题,内容合集,片单,盘点,一起艹',
  );

  return (
    <div className="w-full">
      <PageHeader
        title="精选专题"
        subtitle="把零散的内容整理成体系，从片单到现场、从话题到人物，一次看个明白。"
        crumbs={[{ label: '首页', to: '/' }, { label: '精选专题' }]}
        icon="ri-bookmark-3-line"
      />

      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {specialItems.map((item) => (
            <Link
              key={item.id}
              to={`/detail/${item.id}`}
              className="group flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 cursor-pointer transition-colors"
            >
              <div className="relative w-full aspect-[16/9] bg-background-200 overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={`${item.title} - 一起艹`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                  精选专题
                </span>
              </div>
              <div className="flex flex-col flex-1 p-5 md:p-6">
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h2>
                <p className="mt-3 text-sm text-foreground-500 line-clamp-2">{item.summary}</p>
                <div className="mt-auto pt-5 flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {formatViews(item.views)} 阅读
                  </span>
                  <span className="flex items-center gap-1 text-primary-600 font-medium">
                    进入专题
                    <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 flex justify-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
        </div>
      </div>
    </div>
  );
}